import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import DashboardContainer from '../containers/Dashboard';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CheckIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';

import DgsDialog from '../components/DgsDialog';
import ConwayDialog from '../components/ConwayDialog';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

import fmpLogo from '../images/fmpLogo.png';

const styles = (theme) => {
	return {
		root: {
			width: '100%',
			height: 'auto',
			zIndex: 1,
			overflow: 'hidden',
			backgroundColor: '#e5e5e6',
		},
		panel: {
			marginTop: 30,
		},
		emptyPanel: {
			minHeight: 270,
			fontWeight: 100,
			color: '#aaa',
			fontSize: 30,
			marginTop: 30,
		},
		innerPaper: {
			padding: 10,
			paddingTop: 5,
			textAlign: 'left',
			fontSize: 14,
			[theme.breakpoints.up('md')]: {
				padding: 40,
				paddingTop: 30,
			},
		},
		lastFtpCheck: {
			//marginTop : 20,
			//color : "#888"
		},
		ftpSection: {
			lineHeight: 1.6,
			marginTop: 10,
		},
		title: {
			textTransform: 'uppercase',
			color: '#777',
			fontWeight: 900,
			letterSpacing: 2,
			marginBottom: 5,
		},
		label: {},

		labelDate: {
			fontSize: 12,
			fontWeight: 100,
			color: '#999',
		},
		value: {
			fontWeight: 600,
		},
		statusIcon: {
			position: 'absolute',
			right: 0,
		},
		ftpWarning: {
			color: '#FFC107',
		},
		ftpGood: {
			color: '#4CAF50',
		},
		ftpStatusIcon: {
			width: 14,
			height: 14,
			verticalAlign: 'middle',
			paddingLeft: 5,
		},
		ftpStatusIconLarge: {
			width: 32,
			height: 32,
			verticalAlign: 'middle',
		},
		dataSection: {
			marginTop: 25,
			lineHeight: 1.6,
		},
		dgsButton: {
			position: 'relative',
			right: 0,
			borderRadius: 100,
		},
		dgsButtonContainer: {
			display: 'flex',
			justifyContent: 'flex-end',
			marginTop: 30,
		},
		tableRow: {
			fontWeight: 400,
		},
		row: {
			margin: 0,
			width: '100%',
			backgroundColor: '#fff',
		},
		oddRow: {
			margin: 0,
			width: '100%',
			backgroundColor: '#eee',
		},
		// welcome
		welcomeContainer: {
			display: 'flex',
			alignItems: 'center',
			marginBottom: 15,
			marginTop: 10,
			//background: 'rgb(10,69,112);',
			background: 'linear-gradient(228deg, rgba(12,119,204,1) 0%, rgba(7,46,80,1) 89%);',
			//background: 'linear-gradient(204deg, rgba(10,69,112,1) 3%, rgba(6,28,47,1) 100%);',
			borderRadius: '10px',
			padding: 20,
		},
		welcomeText: {
			fontSize: 55,
			marginLeft: 5,
			color: 'white',
			fontWeight: '1000',
		},
		fmpLogo: {
			display: 'inline-block',
			width: 150,
			height: 150,
			backgroundImage: `url('${fmpLogo}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 5,
			marginLeft: 5,
		},
	};
};

const FILE_ENDING_DISPLAY = {
	'CA_contract_rack_without_CAR.csv': 'LA/SD ContractRackWithoutCar.csv',
	'Ethanol.csv': 'EthanolReport.csv',
	'LCFS_CAR.csv': 'LcfsCarReport.csv',
	'e85prices.txt': 'E85prices.txt (GasBuddy)',
	'WC_Spots.csv': 'WC_Spots.csv (West Coast Spots)',
	'LA_diesel_withCAR_Closing.csv': 'LA Diesel With CAR Closing',
	'LA_diesel_withoutCAR_Closing.csv': 'LA Diesel Without CAR Closing',
	'Conway.csv': 'Conway (Not used)',
	// 'Carbon.csv' : 'Carbon.csv (OPIS Carbon Market Report)',
};

const FIELD_NAME_DISPLAY = {
	'opis.ethanol.laEthCi799.avg': { order: 10, display: 'OPIS Ethanol Spot LA' },
	'opis.ethanol.usEthanolRinCurrent.avg': { order: 20, display: 'Current OPIS Ethanol RINS' },
	'opis.ethanol.usEthanolRin2025.avg': { order: 45, display: '2025 OPIS Ethanol RINS' },
	'opis.ethanol.usEthanolRin2026.avg': { order: 46, display: '2026 OPIS Ethanol RINS' },

	'opis.caContractRackWithoutCar.losAngeles.unbrandedRackLow.unl': {
		order: 28,
		display: 'OPIS LA UBD Rack Low',
	},
	'opis.caContractRackWithoutCar.losAngeles.unbrandedRackAverage.unl': {
		order: 30,
		display: 'OPIS LA UBD Rack Avg',
	},
	'opis.laDieselWithoutCarClosingFields.losAngeles.unbrandedRackAverage.unl': {
		order: 31,
		display: 'OPIS LA UBD Rack Avg (Closing)',
	},
	'opis.caContractRackWithoutCar.losAngeles.pdiWithoutCar.unl': {
		order: 41,
		display: 'OPIS LA PDI Unl Avg',
	},

	'opis.caContractRackWithoutCar.sanDiego.unbrandedRackLow.unl': {
		order: 35,
		display: 'OPIS SD UBD Rack Low',
	},
	'opis.caContractRackWithoutCar.sanDiego.unbrandedRackAverage.unl': {
		order: 36,
		display: 'OPIS SD UBD Rack Avg',
	},

	'opis.caContractRackWithoutCar.sacramento.unbrandedRackAverage.unl': {
		order: 38,
		display: 'OPIS Sac UBD Rack Avg',
	},

	'opis.caContractRackWithoutCar.fresno.unbrandedRackAverage.unl': {
		order: 40,
		display: 'OPIS Fresno UBD Rack Avg',
	},

	'opis.lcfsCar.higherSummerVsWinterCarbRfgUnl': {
		order: 50,
		display: 'OPIS Highest Cap at the rack',
	},
	'opis.lcfsCar.caCarSummerCarbRfgUnl': { order: 52, display: 'OPIS Summer Cap at the rack' },
	'opis.lcfsCar.caCarWinterCarbRfgUnl': { order: 54, display: 'OPIS Winter Cap at the rack' },
	//'opis.lcfsCar.caCcCpgGas90': { order: 60, display: 'OPIS LCFS Cost' },
	'opis.lcfsCar.carbonCpgGasCombinedLcfsCrude.avg': {
		order: 60,
		display: 'OPIS LCFS Cost + Crude',
	},

	'opis.lcfsCar.carbonCredit.avg': { order: 70, display: 'LCFS MT Avg' },
	'opis.lcfsCar.carbonIntensityPtsEthanol.avg': { order: 80, display: 'LCFS Ci Pts Ethanol Avg' },
	'opis.lcfsCar.carbonIntensityPtsBiodiesel.avg': {
		order: 90,
		display: 'LCFS Ci Pts Biodiesel Avg',
	},
	'opis.ethanol.chiEthanol.avg': { order: 100, display: 'OPIS Chicago Ethanol Avg' },
	'opis.ethanol.waEthanol.avg': { order: 110, display: 'OPIS Washington Ethanol Avg' },
	'opis.ethanol.nebEthanol.avg': { order: 115, display: 'OPIS Nebraska Ethanol Avg' },
	'opis.ethanol.nyhEthanol.avg': { order: 117, display: 'OPIS NY Harbor Ethanol Avg' },
	'cmeGroup.nyHarborUlsdFutures.settlement': { order: 120, display: 'CMEGroup Biodiesel Price' },
	'opis.caContractRackWithoutCar.sacramento.unbrandedRackLow.unl': {
		order: 130,
		display: 'Sacramento Unbranded Low',
	},
	'opis.caContractRackWithoutCar.fresno.unbrandedRackLow.unl': {
		order: 130,
		display: 'Fresno Unbranded Low',
	},
	'opis.lcfsCar.carbonCpgDieselCrudeCiDeficit.avg': {
		order: 140,
		display: 'Carbon CPG Crud CI Deficit Avg',
	},
	'opis.wcSpot.laCarbNo2DieselSpot.avg': { order: 142, display: 'LA Diesel Spot Carb No. 2' },
	'opis.wcSpot.caCarCarbNo2.avg': { order: 150, display: 'Cap At The Rack Carb No2 Average' },
	'opis.wcSpot.caLcfsCarbDiesel.avg': { order: 160, display: 'CA LCFS Carb Diesel Avg' },
	// 'opis.carbon.caCarbonCpgDieselCrudCiDeficit.avg' :
	//	{ order : 170, display : 'CGP Diesel Crud Deficit Avg' },

	'opis.wcSpot.caCiDailyBd.avg': { noDisplay: true, display: 'CA Daily BD Posting' },
	'opis.ethanol.usEthanolRin2019.avg': { noDisplay: true, display: '2020 OPIS Ethanol RINS' },
};

const notifierLogColumns = [
	{ id: 'dateCreated', numeric: false, label: 'Batch Sent' },
	{ id: 'jobCount', numeric: false, label: 'Job Count' },
	{ id: 'status', numeric: false, label: 'Status' },
];


function twoDp(num) {
	return num.toFixed(Math.max(2, (num.toString().split('.')[1] || []).length));
}

class Dashboard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isDgsDialogOpen: false,
			isConwayDialogOpen: false,
		};
		this.handleOpenDgsDialog = this.handleOpenDgsDialog.bind(this);
		this.handleCloseDgsDialog = this.handleCloseDgsDialog.bind(this);

		this.handleOpenConwayDialog = this.handleOpenConwayDialog.bind(this);
		this.handleCloseConwayDialog = this.handleCloseConwayDialog.bind(this);
	}

	handleOpenDgsDialog() {
		this.setState({ isDgsDialogOpen: true });
	}

	handleCloseDgsDialog() {
		this.setState({ isDgsDialogOpen: false });
	}

	handleOpenConwayDialog() {
		this.setState({ isConwayDialogOpen: true });
	}

	handleCloseConwayDialog() {
		this.setState({ isConwayDialogOpen: false });
	}

	componentDidMount() {
		if (!this.props.opisFtpRecords.length) {
			this.props.searchOpisFtpRecords({ onlyLatest: true });
		}
		if (!this.props.dataRecords.length) {
			this.props.searchDataRecords({ onlyLatest: true });
		}
		if (!this.props.notifierLogs.length) {
			this.props.searchNotifierLogs();
		}
	}

	render() {
		const {
			classes,
			opisFtpRecords,
			dataRecords,
			notifierLogs,
			userMap,
			authUser,
		} = this.props;

		if (!opisFtpRecords.length || !dataRecords.length || !authUser) {
			return null;
		}

		const isLoadingNotifierLogs = notifierLogs.length === 0;
		const canMakeUpdates = _.get(authUser, ['permissions', 'canMakeUpdates']);

		let njStatus = 'good';
		let overallStatus = 'good';
		let dgsStatus = 'good';
		let conwayStatus = 'good';
		const now = moment();

		/** @namespace ftpRecord.dateDownloaded **/
		/** @namespace ftpRecord.fileEnding **/
		const ftpRecords = opisFtpRecords.map((ftpRecord) => {
			const dlMoment = moment(ftpRecord.dateDownloaded);
			const hoursOld = now.diff(dlMoment, 'hours');
			const status = hoursOld > 75 ? 'warning' : 'good';

			if (status === 'warning') {
				overallStatus = 'warning';
			}
			return _.merge({}, ftpRecord, {
				status: status,
				dateDownloadedFormatted: dlMoment.format('M/D h:mm a'),
				display: FILE_ENDING_DISPLAY[ftpRecord.fileEnding],
			});
		});

		//- notifier logs
		notifierLogs.forEach((log) => {
			log.dateCreatedFormatted = moment(log.dateCreated).format('M/D h:mm a');
			log.statusDisplay = _.capitalize(log.status);
		});

		let lastNotifierLog = _.first(notifierLogs);
		if (!lastNotifierLog || lastNotifierLog.status !== 'success') {
			njStatus = 'warning';
		}

		let lastFtpCheck = undefined;
		let lastPdiFtpCheck = undefined;
		let dgsRate = '?';
		let dgsLastUpdated = undefined;
		let dgsLastUser = '?';

		let conwayRate = '?';
		let conwayLastUpdated = undefined;
		let conwayLastUser = '?';

		let formattedDataRecords = _.reduce(
			dataRecords,
			(result, dataRecord) => {
				/**
				 * @name dataRecord
				 * @property {String} fieldName
				 * @property {Number} fieldValue
				 * @property {Number} createdByUserId
				 * @property {String} dateCreated
				 */

				if (!FIELD_NAME_DISPLAY[dataRecord.fieldName]) {
					if (dataRecord.fieldName === 'opis.lastFtpCheck') {
						lastFtpCheck = moment(dataRecord.fieldValue + 'Z');
					} else if (dataRecord.fieldName === 'pdi.lastFtpCheck') {
						lastPdiFtpCheck = moment(dataRecord.fieldValue + 'Z');
					} else if (dataRecord.fieldName === 'dgs.westCoast.e85Rate') {
						dgsRate = twoDp(parseFloat(dataRecord.fieldValue));

						dgsLastUser = userMap[dataRecord.createdByUserId]
							? userMap[dataRecord.createdByUserId].firstName
							: 'User not found';
						dgsLastUpdated = moment(dataRecord.dateCreated);
					} else if (dataRecord.fieldName === 'opis.conway.inputted.naturalGas.avg') {
						conwayRate = twoDp(parseFloat(dataRecord.fieldValue));

						conwayLastUser = userMap[dataRecord.createdByUserId]
							? userMap[dataRecord.createdByUserId].firstName
							: 'User not found';
						conwayLastUpdated = moment(dataRecord.dateCreated);
					} else {
						//console.warn(`Missing display for field:`, [dataRecord.fieldName]);
					}
					return result;
				}

				dataRecord.fieldValue = twoDp(parseFloat(dataRecord.fieldValue));
				dataRecord.dateCreatedMoment = moment(dataRecord.dateCreated);

				if (FIELD_NAME_DISPLAY[dataRecord.fieldName].noDisplay) {
					return result;
				}

				result.push(
					_.merge({}, dataRecord, {
						fieldNameDisplay: FIELD_NAME_DISPLAY[dataRecord.fieldName].display,
						sortOrder: FIELD_NAME_DISPLAY[dataRecord.fieldName].order,
					})
				);
				return result;
			},
			[]
		);
		formattedDataRecords = _.sortBy(formattedDataRecords, ['sortOrder']);

		let lastFtpCheckStatus = 'good';
		if (!lastFtpCheck || now.diff(lastFtpCheck, 'minutes') > 50) {
			lastFtpCheckStatus = 'warning';
			overallStatus = 'warning';
		}

		//let lastVeederFtpCheckStatus = 'good';
		//if (!lastVeederFtpCheck || now.diff(lastVeederFtpCheck, 'minutes') > 50) {
		//	lastVeederFtpCheckStatus = 'warning';
		//	overallStatus = 'warning';
		//}

		let lastPdiFtpCheckStatus = 'good';
		if (!lastPdiFtpCheck || now.diff(lastPdiFtpCheck, 'minutes') > 130) {
			lastPdiFtpCheckStatus = 'warning';
			overallStatus = 'warning';
		}

		if (!dgsLastUpdated || now.diff(dgsLastUpdated, 'days') > 8) {
			dgsStatus = 'warning';
		}

		if (!conwayLastUpdated || now.diff(conwayLastUpdated, 'days') > 8) {
			conwayStatus = 'warning';
		}

		let isOdd = true;
		const statusIcon = {
			error: (
				<span className={classes.ftpWarning}>
					<WarningIcon className={classes.ftpStatusIcon} />
				</span>
			),
			warning: (
				<span className={classes.ftpWarning}>
					<WarningIcon className={classes.ftpStatusIcon} />
				</span>
			),
			success: (
				<span className={classes.ftpGood}>
					<CheckIcon className={classes.ftpStatusIcon} />
				</span>
			),
			good: (
				<span className={classes.ftpGood}>
					<CheckIcon className={classes.ftpStatusIcon} />
				</span>
			),
		};

		return (
			<Grid container spacing={3}>
				{/*
				<Grid item xs={12} md={12}>
					<div className={classes.welcomeContainer}>
						<div className={classes.fmpLogo} />
						<div className={classes.welcomeText}>Welcome {authUser?.firstName}!</div>
					</div>
				</Grid>
		*/}

				<Grid item xs={12} md={6}>
					<Paper>
						<div className={classes.innerPaper}>
							<Typography variant="h5" align="left" gutterBottom style={{ position: 'relative' }}>
								OPIS, Veeder, and PDI import status
								<span style={{ position: 'absolute', right: 0 }}>
									{overallStatus === 'warning' && (
										<span className={classes.ftpWarning}>
											<WarningIcon className={classes.ftpStatusIconLarge} />
										</span>
									)}
									{overallStatus === 'good' && (
										<span className={classes.ftpGood}>
											<CheckIcon className={classes.ftpStatusIconLarge} />
										</span>
									)}
								</span>
							</Typography>

							<div className={classes.ftpSection}>
								<div className={classes.title}>Latest Files</div>
								<div>
									{ftpRecords.map((opisFtpRecord) => {
										return (
											<div key={opisFtpRecord.opisFtpRecordId}>
												{(isOdd = !isOdd)}
												<Grid container spacing={2} className={classes[isOdd ? 'row' : 'oddRow']}>
													<Grid item xs={8} style={{ textAlign: 'left' }}>
														<span className={classes.label}>{opisFtpRecord.display}</span>
													</Grid>
													<Grid item xs={4} style={{ textAlign: 'right' }}>
														<span className={classes.value}>
															{opisFtpRecord.dateDownloadedFormatted}
														</span>
														{statusIcon[opisFtpRecord.status]}
													</Grid>
												</Grid>
											</div>
										);
									})}

									<div className={classes.lastFtpCheck}>
										{(isOdd = !isOdd)}
										<Grid container spacing={2} className={classes[isOdd ? 'row' : 'oddRow']}>
											<Grid item xs={8} style={{ textAlign: 'left' }}>
												<span className={classes.label}>Last OPIS ftp scan </span>
											</Grid>
											<Grid item xs={4} style={{ textAlign: 'right' }}>
												<span className={classes.value}>
													{lastFtpCheck && lastFtpCheck.format('M/D h:mm a')}
												</span>
												{statusIcon[lastFtpCheckStatus]}
											</Grid>
										</Grid>
									</div>

									{/*
									<div className={classes.lastFtpCheck}>
										{(isOdd = !isOdd)}
										<Grid container spacing={2} className={classes[isOdd ? 'row' : 'oddRow']}>
											<Grid item xs={8} style={{ textAlign: 'left' }}>
												<span className={classes.label}>Last Veeder ftp scan </span>
											</Grid>
											<Grid item xs={4} style={{ textAlign: 'right' }}>
												<span className={classes.value}>
													{lastVeederFtpCheck && lastVeederFtpCheck.format('M/D h:mm a')}
												</span>
												{statusIcon[lastVeederFtpCheckStatus]}
											</Grid>
										</Grid>
									</div>
								*/}

									<div className={classes.lastFtpCheck}>
										{(isOdd = !isOdd)}
										<Grid container spacing={2} className={classes[isOdd ? 'row' : 'oddRow']}>
											<Grid item xs={8} style={{ textAlign: 'left' }}>
												<span className={classes.label}>Last PDI ftp scan </span>
											</Grid>
											<Grid item xs={4} style={{ textAlign: 'right' }}>
												<span className={classes.value}>
													{lastPdiFtpCheck && lastPdiFtpCheck.format('M/D h:mm a')}
												</span>
												{statusIcon[lastPdiFtpCheckStatus]}
											</Grid>
										</Grid>
									</div>
								</div>
							</div>

							<div className={classes.dataSection}>
								<div className={classes.title}>Latest Data</div>
								<div>
									{formattedDataRecords.map((dataRecord) => {
										return (
											<div key={dataRecord.dataRecordId}>
												{(isOdd = !isOdd)}
												<Grid container spacing={2} className={classes[isOdd ? 'row' : 'oddRow']}>
													<Grid item xs={8} style={{ textAlign: 'left', lineHeight: 1.3 }}>
														<span className={classes.label}>{dataRecord.fieldNameDisplay}</span>
														<br />
														<span className={classes.labelDate}>
															{dataRecord.dateCreatedMoment.format('M/D h:mm a')}
														</span>
													</Grid>
													<Grid item xs={4} style={{ textAlign: 'right' }}>
														<span className={classes.value}>{dataRecord.fieldValue}</span>
													</Grid>
												</Grid>
											</div>
										);
									})}
								</div>
							</div>
						</div>
					</Paper>
				</Grid>
				<Grid item xs={12} md={6}>
					<Paper className={classes.panel} style={{ marginTop: 0 }}>
						<div className={classes.innerPaper}>
							{isLoadingNotifierLogs && <div>Notifier Logs are loading...</div>}
							{!isLoadingNotifierLogs && (
								<div>
									<Typography
										variant="h5"
										align="left"
										gutterBottom
										style={{ position: 'relative' }}
									>
										Notification Job Status
										<span style={{ position: 'absolute', right: 0 }}>
											{njStatus === 'warning' && (
												<span className={classes.ftpWarning}>
													<WarningIcon className={classes.ftpStatusIconLarge} />
												</span>
											)}
											{njStatus === 'good' && (
												<span className={classes.ftpGood}>
													<CheckIcon className={classes.ftpStatusIconLarge} />
												</span>
											)}
										</span>
									</Typography>

									<div className={classes.dataSection}>
										<Table>
											<TableHead>
												<TableRow>
													{notifierLogColumns.map((c) => {
														return (
															<TableCell key={c.id} align={c.numeric ? 'right' : 'left'}>
																<TableSortLabel>{c.label}</TableSortLabel>
															</TableCell>
														);
													}, this)}
												</TableRow>
											</TableHead>
											<TableBody>
												{notifierLogs.map((log) => {
													return (
														<TableRow hover className={classes.tableRow} key={log.notifierLogId}>
															<TableCell>{log.dateCreatedFormatted}</TableCell>
															<TableCell>{log.jobCount}</TableCell>
															<TableCell>
																{log.statusDisplay}
																{statusIcon[log.status]}
															</TableCell>
														</TableRow>
													);
												})}
											</TableBody>
										</Table>
									</div>
								</div>
							)}
						</div>
					</Paper>

					<Paper className={classes.panel} style={{ minHeight: 100 }}>
						<div className={classes.innerPaper}>
							<Typography variant="h5" align="left" gutterBottom style={{ position: 'relative' }}>
								DGS data
								<span style={{ position: 'absolute', right: 0 }}>
									{dgsStatus === 'warning' && (
										<span className={classes.ftpWarning}>
											<WarningIcon className={classes.ftpStatusIconLarge} />
										</span>
									)}
									{dgsStatus === 'good' && (
										<span className={classes.ftpGood}>
											<CheckIcon className={classes.ftpStatusIconLarge} />
										</span>
									)}
								</span>
							</Typography>

							<div className={classes.dataSection}>
								{(isOdd = !isOdd)}
								<Grid container spacing={2} className={classes[isOdd ? 'row' : 'oddRow']}>
									<Grid item xs={8} style={{ textAlign: 'left' }}>
										<span className={classes.label}>Current DGS west coast E85 rate</span>
									</Grid>
									<Grid item xs={4} style={{ textAlign: 'right' }}>
										<span className={classes.value}>{dgsRate}</span>
									</Grid>
								</Grid>

								{(isOdd = !isOdd)}
								<Grid container spacing={2} className={classes[isOdd ? 'row' : 'oddRow']}>
									<Grid item xs={8} style={{ textAlign: 'left' }}>
										<span className={classes.label}>Last updated</span>
									</Grid>
									<Grid item xs={4} style={{ textAlign: 'right' }}>
										<span className={classes.value}>
											{dgsLastUpdated && dgsLastUpdated.format('M/D h:mm a')}
										</span>
									</Grid>
								</Grid>

								{(isOdd = !isOdd)}
								<Grid container spacing={2} className={classes[isOdd ? 'row' : 'oddRow']}>
									<Grid item xs={8} style={{ textAlign: 'left' }}>
										<span className={classes.label}>Last updated by</span>
									</Grid>
									<Grid item xs={4} style={{ textAlign: 'right' }}>
										<span className={classes.value}>{dgsLastUser}</span>
									</Grid>
								</Grid>

								{canMakeUpdates && (
									<div className={classes.dgsButtonContainer}>
										<Button
											color="primary"
											className={classes.dgsButton}
											onClick={() => this.handleOpenDgsDialog()}
										>
											Update DGS data
										</Button>
									</div>
								)}
							</div>
						</div>
					</Paper>

					<Paper className={classes.panel} style={{ minHeight: 100 }}>
						<div className={classes.innerPaper}>
							<Typography variant="h5" align="left" gutterBottom style={{ position: 'relative' }}>
								Conway Natural Gas Pricing
								<span style={{ position: 'absolute', right: 0 }}>
									{conwayStatus === 'warning' && (
										<span className={classes.ftpWarning}>
											<WarningIcon className={classes.ftpStatusIconLarge} />
										</span>
									)}
									{conwayStatus === 'good' && (
										<span className={classes.ftpGood}>
											<CheckIcon className={classes.ftpStatusIconLarge} />
										</span>
									)}
								</span>
							</Typography>

							<div className={classes.dataSection}>
								{(isOdd = !isOdd)}
								<Grid container spacing={2} className={classes[isOdd ? 'row' : 'oddRow']}>
									<Grid item xs={8} style={{ textAlign: 'left' }}>
										<span className={classes.label}>Current Conway pricing (average)</span>
									</Grid>
									<Grid item xs={4} style={{ textAlign: 'right' }}>
										<span className={classes.value}>{conwayRate}</span>
									</Grid>
								</Grid>

								{(isOdd = !isOdd)}
								<Grid container spacing={2} className={classes[isOdd ? 'row' : 'oddRow']}>
									<Grid item xs={8} style={{ textAlign: 'left' }}>
										<span className={classes.label}>Last updated</span>
									</Grid>
									<Grid item xs={4} style={{ textAlign: 'right' }}>
										<span className={classes.value}>
											{conwayLastUpdated && conwayLastUpdated.format('M/D h:mm a')}
										</span>
									</Grid>
								</Grid>

								{(isOdd = !isOdd)}
								<Grid container spacing={2} className={classes[isOdd ? 'row' : 'oddRow']}>
									<Grid item xs={8} style={{ textAlign: 'left' }}>
										<span className={classes.label}>Last updated by</span>
									</Grid>
									<Grid item xs={4} style={{ textAlign: 'right' }}>
										<span className={classes.value}>{conwayLastUser}</span>
									</Grid>
								</Grid>

								{canMakeUpdates && (
									<div className={classes.dgsButtonContainer}>
										<Button
											color="primary"
											className={classes.dgsButton}
											onClick={() => this.handleOpenConwayDialog()}
										>
											Update DGS data
										</Button>
									</div>
								)}
							</div>
						</div>
					</Paper>
				</Grid>
				<DgsDialog
					onClose={this.handleCloseDgsDialog}
					addDataRecord={this.props.addDataRecord}
					currentDgsValue={dgsRate}
					open={this.state.isDgsDialogOpen}
				/>

				<ConwayDialog
					onClose={this.handleCloseConwayDialog}
					addDataRecord={this.props.addDataRecord}
					currentConwayValue={conwayRate}
					open={this.state.isConwayDialogOpen}
				/>
			</Grid>
		);
	}
}

Dashboard.propTypes = {
	classes: PropTypes.object.isRequired,
	searchOpisFtpRecords: PropTypes.func.isRequired,
	opisFtpRecords: PropTypes.array,

	searchDataRecords: PropTypes.func.isRequired,
	dataRecords: PropTypes.array,
	addDataRecord: PropTypes.func.isRequired,

	searchNotifierLogs: PropTypes.func.isRequired,
	notifierLogs: PropTypes.array,

	userMap: PropTypes.object,
	authUser: PropTypes.object,
};

export default _.flow([withStyles(styles), DashboardContainer])(Dashboard);
